export function Logo({ size = 36, dark = false, stacked = false }: { size?: number; dark?: boolean; stacked?: boolean }) {
  return (
    <span className={`inline-flex ${stacked ? "flex-col items-center gap-2" : "items-center gap-2.5"}`} data-testid="bhasa-logo">
      <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-label="Bhasa Hands Bridge logo">
        <path d="M6 40c0-9 5-16 12-20l6-3c2-1 4 0 4 2v9l-3 3c-4 4-6 9-6 14v9c0 2-2 3-3 2C10 53 6 47 6 40z" fill="#1E40AF" />
        <path d="M58 40c0-9-5-16-12-20l-6-3c-2-1-4 0-4 2v9l3 3c4 4 6 9 6 14v9c0 2 2 3 3 2 6-3 10-9 10-16z" fill="#059669" />
        <path d="M32 50l-8.5-8.6c-2.6-2.7-2.6-7 0-9.7 2.4-2.5 6.3-2.5 8.5 0 2.2-2.5 6.1-2.5 8.5 0 2.6 2.7 2.6 7 0 9.7L32 50z" fill="#D4AF37" />
      </svg>
      <span className={`font-heading font-bold leading-none ${stacked ? "text-center" : ""}`}>
        <span className={`block text-[15px] tracking-tight ${dark ? "text-white" : "text-brand-navy"}`}>Bhasa</span>
        <span className={`block text-[10px] font-semibold uppercase tracking-[0.18em] ${dark ? "text-slate-300" : "text-brand-slate"}`}>Global Care Network</span>
      </span>
    </span>
  );
}
